import styled from '@emotion/styled'
import { inject, observer } from 'mobx-react'
import { withRouterProps } from '../../../../utils'
import { TABLET } from '../../../../guided-toolbox/utils/breakpoints'
import { LeftSideBar, SideBarDrawer } from './'

const SideBox = styled.div`
  flex: 0 0 auto;
  display: flex;
  ${TABLET} {
    display: none;
  }
`

const SideBar = props => {
  if (props.main.enableSidebar !== undefined && props.main.enableSidebar === false) {
    return null
  }

  return (
    <SideBox>
      <LeftSideBar {...props} />
      <SideBarDrawer {...props} />
    </SideBox>
  )
}

export default withRouterProps(inject('store', 'main')(observer(SideBar)))
